import {interpolateArray} from "../../../charts/StockChart/interpolate";
import {isUUID} from "../../../utils/strings";
import {COLD_PALETTE} from "../../../utils/colorUtils";


export const formatDataForStockChart = (portfolioTimeSeries, benchmarkTimeSeries, extraTimeseries, snapshotCallback, portfolio)=>{
    const dataSeries = [];
    if (portfolioTimeSeries) {
        const closeValues = interpolateArray(portfolioTimeSeries.map(x => x.close));
        dataSeries.push({
            name: portfolio?.name,
            type: 'line',
            data: portfolioTimeSeries.map(x => [x.timestamp, closeValues[portfolioTimeSeries.indexOf(x)], x.snapshot]),
            stroke: '#105DEB',
            thickness: 2,
            hasSnapshot: true,
            callbackOnSnapshot: snapshotCallback
        });
    }

    if (benchmarkTimeSeries){
        dataSeries.push({
            name: portfolio?.benchmark,
            type: 'area',
            data: benchmarkTimeSeries.map(x => [x.timestamp, x['adj close']]),
            stroke: 'rgba(160, 184, 202, 1)',
            fill: {
                keys: ['rgba(160, 184, 202, 0.5)', 'rgba(160, 184, 202, 0.1)'],
                angle: 270
            }
        });
    }
    if (extraTimeseries){
        extraTimeseries.forEach((extraSeries, index)=>{
            if (extraSeries.symbol !== portfolio?.benchmark && !isUUID(extraSeries.symbol))
            dataSeries.push({
                name: extraSeries.symbol,
                type: 'line',
                data: extraSeries.data.map(x => [x.timestamp, x['adj close']]),
                stroke: COLD_PALETTE[index < COLD_PALETTE.length ? index : index % COLD_PALETTE.length],
                strokeWidth: 2,
            });
        })
    }
    return dataSeries;
}